import API from "../../../../../global/api";
// import _ from "lodash";


export const requestGenerateSalary = () => {
    return {
        type: "REQUEST_GENERATE_SALARY",
    };
};
export const successGenerateSalary = (data) => {
    return {
        type: "SUCCESS_GENERATE_SALARY",
        payload: data,
    };
};
export const errorGenerateSalary = () => {
    return {
        type: "ERROR_GENERATE_SALARY",
    };
};
export const GenerateSalaryApi = (payload, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestGenerateSalary());
        API.post(`/salary/generate-salary`, payload).then((res) => {
            let getData = res.data;
            dispatch(successGenerateSalary(getData));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorGenerateSalary());
            handleDangerVisible(error.response.data.message)
        })
    };
};